import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmProvider } from '@/components';
import App from './App';
import './styles/global.scss';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/* Above App so any screen can ask a question, and the dialog renders
          over the whole shell rather than inside a scrolling panel. */}
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  </StrictMode>,
);
